module.exports = __webpack_public_path__ + "static/media/med.68e2b82f.jpg";